import PropTypes from 'prop-types';
import styled from 'styled-components';

import type { CommonProps, FlexboxProps, LayoutProps } from './constants';
import { COMMON, FLEXBOX, LAYOUT } from './constants';
import theme from './theme';

type Props = CommonProps & LayoutProps & FlexboxProps & { as?: keyof JSX.IntrinsicElements | React.ComponentType<any> };

const Flex = styled.div<Props>`
  ${FLEXBOX}
  ${COMMON}
  ${LAYOUT}
`;

Flex.defaultProps = {
  theme,
  display: 'flex',
};

// TODO: Flex and flex item should only allow subsets of the FLEXBOX props
Flex.propTypes = {
  ...COMMON.propTypes,
  ...FLEXBOX.propTypes,
  ...LAYOUT.propTypes,
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  theme: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

type ItemProps = CommonProps & FlexboxProps & { as?: keyof JSX.IntrinsicElements | React.ComponentType<any> };

// TODO: Flex and flex item should only allow subsets of the FLEXBOX props
const Item = styled.div<ItemProps>`
  ${FLEXBOX} ${COMMON};
`;

Item.defaultProps = {
  theme,
};

Item.propTypes = {
  ...COMMON.propTypes,
  ...FLEXBOX.propTypes,
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  theme: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

Flex.displayName = 'Flex';
Item.displayName = 'Flex.Item';

(Flex as any).Item = Item;
const FullFlex: typeof Flex & { Item: typeof Item } = Flex as any;

export { FullFlex as Flex };
